import React from 'react';

export const ArrowUp = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={41} height={41} viewBox="0 0 41 41" >
      <polygon points="37.647 20.534 21.647 1.534 19.353 1.534 3.353 20.534 5.647 22.466 19 6.61 19 39 22 39 22 6.61 35.353 22.466 37.647 20.534"/>
    </svg>
  )
}

export const Instagram = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={41} height={41} viewBox="0 0 41 41">
      <path d="M31,5a5.0057,5.0057,0,0,1,5,5V31a5.0057,5.0057,0,0,1-5,5H10a5.0057,5.0057,0,0,1-5-5V9A4.0045,4.0045,0,0,1,9,5H31m0-3H9A7,7,0,0,0,2,9V31a8,8,0,0,0,8,8H31a8,8,0,0,0,8-8V10a8,8,0,0,0-8-8Z"/>
      <path d="M20.5,13A7.5,7.5,0,1,1,13,20.5,7.5085,7.5085,0,0,1,20.5,13m0-3A10.5,10.5,0,1,0,31,20.5,10.5,10.5,0,0,0,20.5,10Z"/>
      <path d="M31.5,8A1.5,1.5,0,1,1,30,9.5,1.5017,1.5017,0,0,1,31.5,8m0-1A2.5,2.5,0,1,0,34,9.5,2.5,2.5,0,0,0,31.5,7Z"/>
    </svg>
  )
}




// WEBPACK FOOTER //
// ./src/components/Icons.js